import { render, staticRenderFns } from "./fkjz_index.vue?vue&type=template&id=21dca023&scoped=true&"
import script from "./fkjz_index.vue?vue&type=script&lang=js&"
export * from "./fkjz_index.vue?vue&type=script&lang=js&"
import style0 from "./fkjz_index.vue?vue&type=style&index=0&id=21dca023&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dca023",
  null
  
)

export default component.exports